export default __webpack_public_path__ + "static/media/aditya-birla-capitalL.7114ad3a.svg";